define( function() {
	"use strict";

	return { guid: Date.now() };
} );



//////////////////
// WEBPACK FOOTER
// ./~/_jquery@3.6.0@jquery/src/ajax/var/nonce.js
// module id = 390
// module chunks = 0